<template>
  <div
    class="app-main"
    :style="{ paddingBottom: safeBottom + 'px' }"
  >
    <template v-if="$route.meta.keepAlive">
      <keep-alive ref="keepAlive">
        <router-view />
      </keep-alive>
    </template>
    <router-view v-else />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import util from '@/utils/utils';
import {isAlps, isFyCN} from "@/utils/brandUtils";

const safeBottom = ref(0);
/** 处理顶部导航栏 statebar问题*/
async function getOsInfoSetPadding() {
  setTimeout(async () => {
    const osInfo = await util.getBottomSafeArea() || {};
    safeBottom.value = osInfo?.bottom_bar_height || 0;
  }, 0);
}

onMounted(async() => {
  util.initVConsole();
  await getOsInfoSetPadding();
  if (isAlps()) {
    import('@nio-fe/horo-h5/dist/style.alps.css')
      .then(() => console.log('Alps brand style loaded'))
      .catch(err => console.error('Failed to load Alps style:', err));
  } else if (isFyCN()) {
    import('@nio-fe/horo-h5/dist/style.fy.css')
      .then(() => console.log('Alps brand style loaded'))
      .catch(err => console.error('Failed to load Alps style:', err));
  } else {
    import('@nio-fe/horo-h5/dist/style.css')
      .then(() => console.log('Default brand style loaded'))
      .catch(err => console.error('Failed to load Default style:', err));
  }

});
</script>
